import { getAnalytics, logEvent } from "firebase/analytics";
import { getPerformance, PerformanceTrace, trace } from "firebase/performance";
import { initializeApp } from 'firebase/app';
import { Injectable } from "@angular/core";
import { logger } from "src/app/common/services/logging/logging.service";
import { NavigationEnd, Router, Event } from '@angular/router';
import { combineLatest, distinctUntilChanged, filter } from 'rxjs';
import { ExternalSettingsService } from "src/app/common/services/external-settings/external-settings.service";
import { StringUtilityService } from "./string-utility.service";


@Injectable({
    providedIn: 'root'
})

export class PerformanceService {

    private static isEnable = false;
    private static trace: PerformanceTrace | null;
    private static serviceName: string = "";

    constructor(
        private srvES: ExternalSettingsService,
        private router: Router
    ) { }


    public init() {

        combineLatest([this.srvES.externalSettings$]).subscribe(([externalSettings]) => {

            if (!externalSettings) return;
            
            let firebaseConfig = externalSettings.globalVariables.firebaseConfig;

            if (!StringUtilityService.isValidJSON(firebaseConfig)) return;

            // Initialize the Firebase Analytics
            const app = initializeApp(JSON.parse(firebaseConfig));
            getAnalytics(app);
            getPerformance(app);

            PerformanceService.isEnable = true;

            // Use the Page as the Event Name
            this.router.events.pipe(
                filter((zevent: Event) => zevent instanceof NavigationEnd),
                distinctUntilChanged(),
            ).subscribe(() => {
                PerformanceService.serviceName = this.router.url.substring(1);

                // Start the Default Trace 
                PerformanceService.startTrace();
            })
        });
    }

    /**
     * Please note that this startTrace will create a new trace with the same name, the previous trace will be cancelled.
     */
    public static startTrace() {
        if (!PerformanceService.isEnable) return;
        PerformanceService.trace = trace(getPerformance(), PerformanceService.serviceName);
        PerformanceService.trace.start();
        logger.debug(`Performance trace started: ${PerformanceService.serviceName}`);
    }

    public static stopTrace() {
        if (!PerformanceService.isEnable) return;
        if (PerformanceService.trace) {
            PerformanceService.trace.stop();
            PerformanceService.trace = null;
            logger.debug(`Performance trace stopped: ${PerformanceService.serviceName}`);
        }
    }

    public static logEvent(eventParams?: LogEvent) {
        if (!PerformanceService.isEnable) return;
        logEvent(getAnalytics(), PerformanceService.serviceName, eventParams);
    }
}

export interface LogEvent {
    [key: string]: any;
}